var _defs, _polygon, _polygon2, _polygon3, _polygon4, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgBindingIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "25 8 23.3721 9.1621 28.542 16 23.386 22.8379 25.0139 24 31 16 25 8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "20 8 18.3721 9.1621 23.542 16 18.386 22.8379 20.0139 24 26 16 20 8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.6279 9.1621 7 8 1 16 6.9861 24 8.614 22.8379 3.458 16 8.6279 9.1621"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12 8 6 16 11.9861 24 13.614 22.8379 8.458 16 13.6279 9.1621 12 8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "&lt;Transparent Rectangle&gt;",
    className: "cls-1",
    width: 32,
    height: 32
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgBindingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/binding-icon.324e5f8c45a77716fc40089167d58f6d.svg";